function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "m416.042969 208c4.417969 0 8-3.582031 8-8v-192c0-4.417969-3.582031-8-8-8-34.617188 0-88 27.488281-88 64v8h-168c-22.082031.027344-39.972657 17.917969-40 40v38.121094c-7.984375 7.085937-13.371094 16.636718-15.3125 27.136718-48.394531 7.257813-85.179688 47.277344-88.351563 96.109376-11.136718 3.730468-17.917968 14.988281-16.015625 26.578124 1.90625 11.589844 11.9375 20.085938 23.679688 20.054688h240c11.742187.03125 21.773437-8.464844 23.679687-20.054688 1.902344-11.589843-4.878906-22.847656-16.015625-26.578124-3.171875-48.832032-39.957031-88.851563-88.351562-96.109376-1.941407-10.5-7.328125-20.050781-15.3125-27.136718v-30.121094h160v24c0 36.511719 53.382812 64 88 64zm-72-144c0-23.199219 36.894531-43.792969 64-47.433594v174.867188c-27.105469-3.640625-64-24.234375-64-47.433594zm-177.441407 112h-45.117187c2.703125-8.121094 8.796875-16 14.558594-16h16c5.785156 0 11.855469 7.878906 14.558593 16zm97.441407 128h-240c-4.417969 0-8-3.582031-8-8s3.582031-8 8-8h240c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8zm-8.359375-32h-223.28125c4.191406-45.289062 42.160156-79.945312 87.640625-80h48c45.480469.054688 83.449219 34.710938 87.640625 80zm-95.640625-168c-4.417969 0-8 3.582031-8 8v32h-16v-32c0-13.253906 10.746093-24 24-24h168v16zm0 0"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m40.042969 344c0-4.417969-3.582031-8-8-8s-8 3.582031-8 8v8c0 4.417969 3.582031 8 8 8s8-3.582031 8-8zm0 0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m72.042969 344c0-4.417969-3.582031-8-8-8s-8 3.582031-8 8v48c0 4.417969 3.582031 8 8 8s8-3.582031 8-8zm0 0"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m104.042969 344c0-4.417969-3.582031-8-8-8s-8 3.582031-8 8v8c0 4.417969 3.582031 8 8 8s8-3.582031 8-8zm0 0"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m136.042969 344c0-4.417969-3.582031-8-8-8s-8 3.582031-8 8v48c0 4.417969 3.582031 8 8 8s8-3.582031 8-8zm0 0"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m168.042969 344c0-4.417969-3.582031-8-8-8s-8 3.582031-8 8v8c0 4.417969 3.582031 8 8 8s8-3.582031 8-8zm0 0"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m200.042969 344c0-4.417969-3.582031-8-8-8s-8 3.582031-8 8v48c0 4.417969 3.582031 8 8 8s8-3.582031 8-8zm0 0"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m232.042969 344c0-4.417969-3.582031-8-8-8s-8 3.582031-8 8v8c0 4.417969 3.582031 8 8 8s8-3.582031 8-8zm0 0"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "m64.042969 416c-4.417969 0-8 3.582031-8 8v24c0 4.417969 3.582031 8 8 8s8-3.582031 8-8v-24c0-4.417969-3.582031-8-8-8zm0 0"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "m128.042969 416c-4.417969 0-8 3.582031-8 8v24c0 4.417969 3.582031 8 8 8s8-3.582031 8-8v-24c0-4.417969-3.582031-8-8-8zm0 0"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "m192.042969 416c-4.417969 0-8 3.582031-8 8v24c0 4.417969 3.582031 8 8 8s8-3.582031 8-8v-24c0-4.417969-3.582031-8-8-8zm0 0"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "m256.042969 416c-4.417969 0-8 3.582031-8 8v24c0 4.417969 3.582031 8 8 8s8-3.582031 8-8v-24c0-4.417969-3.582031-8-8-8zm0 0"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "m264.042969 344c0-4.417969-3.582031-8-8-8s-8 3.582031-8 8v48c0 4.417969 3.582031 8 8 8s8-3.582031 8-8zm0 0"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "m40.042969 384c0-4.417969-3.582031-8-8-8s-8 3.582031-8 8v48c0 4.417969 3.582031 8 8 8s8-3.582031 8-8zm0 0"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "m104.042969 384c0-4.417969-3.582031-8-8-8s-8 3.582031-8 8v48c0 4.417969 3.582031 8 8 8s8-3.582031 8-8zm0 0"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "m168.042969 384c0-4.417969-3.582031-8-8-8s-8 3.582031-8 8v48c0 4.417969 3.582031 8 8 8s8-3.582031 8-8zm0 0"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "m232.042969 384c0-4.417969-3.582031-8-8-8s-8 3.582031-8 8v48c0 4.417969 3.582031 8 8 8s8-3.582031 8-8zm0 0"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "m35.082031 456.550781c-1.476562-.570312-3.085937-.707031-4.640625-.390625-.488281.097656-.96875.226563-1.4375.390625-.496094.242188-.980468.507813-1.449218.800781-.414063.296876-.8125.617188-1.191407.960938-.707031.777344-1.273437 1.671875-1.679687 2.640625-.449219.949219-.667969 1.996094-.640625 3.046875-.039063 3.257812 1.902343 6.210938 4.90625 7.472656 3 1.257813 6.46875.570313 8.765625-1.738281s2.964844-5.777344 1.6875-8.773437c-.386719-.980469-.957032-1.875-1.679688-2.640626-.796875-.703124-1.6875-1.296874-2.640625-1.769531zm0 0"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "m90.363281 458.320312c-.722656.765626-1.292969 1.660157-1.679687 2.640626-1.277344 2.976562-.609375 6.429687 1.679687 8.71875.765625.722656 1.660157 1.292968 2.640625 1.679687 2.976563 1.277344 6.429688.613281 8.71875-1.679687 2.292969-2.289063 2.957032-5.742188 1.679688-8.71875-.40625-.96875-.972656-1.863282-1.679688-2.640626-3.207031-2.960937-8.152344-2.960937-11.359375 0zm0 0"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "m164.441406 457.359375c-.425781-.308594-.882812-.574219-1.359375-.800781-.496093-.171875-1.007812-.304688-1.527343-.390625-1.523438-.3125-3.105469-.175781-4.550782.390625-.957031.472656-1.84375 1.066406-2.640625 1.769531-.722656.765625-1.292969 1.660156-1.679687 2.640625-1.277344 2.976562-.609375 6.429688 1.679687 8.71875.777344.707031 1.671875 1.273438 2.640625 1.679688 2.976563 1.277343 6.429688.613281 8.71875-1.679688 2.292969-2.289062 2.957032-5.742188 1.679688-8.71875-.40625-.96875-.972656-1.863281-1.679688-2.640625-.394531-.363281-.820312-.6875-1.28125-.96875zm0 0"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "m218.363281 458.320312c-.722656.765626-1.292969 1.660157-1.679687 2.640626-.449219.949218-.667969 1.988281-.640625 3.039062-.019531 2.128906.816406 4.175781 2.320312 5.679688.777344.707031 1.671875 1.273437 2.640625 1.679687 2.460938 1.054687 5.285156.796875 7.511719-.6875s3.554687-3.996094 3.527344-6.671875c.023437-1.050781-.195313-2.089844-.640625-3.039062-.40625-.96875-.972656-1.863282-1.679688-2.640626-3.207031-2.960937-8.152344-2.960937-11.359375 0zm0 0"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    height: "472pt",
    viewBox: "-24 0 472 472.09405",
    width: "472pt"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

export default __webpack_public_path__ + "static/media/shower.dcac6d54.svg";
export { SvgComponent as ReactComponent };